import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type MediaBriefAgentProps = {
  parsedContent: any;
  handleSuggestionClick: (suggestion: string) => void;
};

export default function MediaBriefAgent({
  parsedContent,
  handleSuggestionClick,
}: MediaBriefAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);
  const question = parsedContent?.question;
  const mediaBreiefPayload = finalAnswer?.payload;

  return (
    <div>
      <div className={styles.mediaBriefMain}>
        <h4>Media Briefing: Press Release Q&A </h4>
        {/* <h4> Interviewee Profile:</h4> */}
        {mediaBreiefPayload?.interviewee_profile}
      </div>
      <div className={styles.mediaBriefMain}>
        <h4>Strategic Narrative (Top-Level Messaging):</h4>
        {mediaBreiefPayload?.strategic_narrative}
      </div>
      <div className={styles.mediaBrief}>
        <h4>Key strategic points the CEO must emphasize:</h4>
        <ul>
          {(mediaBreiefPayload?.key_strategic_points || []).map(
            (body: string, idx: number) => (
              <li key={idx}>{body}</li>
            )
          )}
        </ul>
      </div>
      <div>
        <div className={styles.qa}>Q&A</div>
        {mediaBreiefPayload?.qa_set?.map((qa: any, idx: number) => (
          <div className={styles.qaList} key={idx}>
            <p className={styles.qaAnswer}>
              <strong>Q{idx + 1}:</strong> {qa.question}
            </p>
            <p className={styles.riskLevel}>
              {qa.risk_level === "MEDIUM" || qa.risk_level === "HIGH" ? (
                <span style={{ color: "#f00" }}>
                  High Risk: Potentially sensitive
                </span>
              ) : (
                qa.risk_level === "LOW" && (
                  <span style={{ color: "#004141" }}>Low Risk</span>
                )
              )}
            </p>
            {qa.risk_level === "MEDIUM" || qa.risk_level === "HIGH" ? (
              Array.isArray(qa.answer) ? (
                qa.answer.map((ans: any, ansIdx: number) => (
                  <p className={styles.qaAnswer} key={ansIdx}>
                    <strong>
                      A{idx + 1}
                      {qa.answer.length > 1
                        ? ` (Option ${ansIdx + 1} - ${ans.strategy_used})`
                        : ""}
                      :
                    </strong>
                    &nbsp;
                    {ans.text}
                  </p>
                ))
              ) : (
                <p className={styles.qaAnswer}>
                  <strong>A{idx + 1}:</strong>&nbsp;{qa.answer}
                </p>
              )
            ) : (
              <p className={styles.qaAnswer}>
                <strong>A{idx + 1}:</strong>&nbsp;
                {Array.isArray(qa.answer)
                  ? qa.answer[0]?.text || qa.answer
                  : qa.answer}
              </p>
            )}
          </div>
        ))}
      </div>
      {finalAnswer?.payload?.suggestions &&
        finalAnswer?.payload?.suggestions?.length > 0 && (
          <div className={styles.suggestionsContainer}>
            {finalAnswer?.payload?.suggestions?.map(
              (suggestion: string, idx: number) => (
                <div
                  className={styles.suggestionBox}
                  key={idx}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <p>{suggestion}</p>
                </div>
              )
            )}
          </div>
        )}
      <div className={styles.finalQuestion}>{question}</div>
    </div>
  );
}
